import React from "react";
import { Calendar } from "./ui/calendar";
import { fr as frLocale, enUS } from "date-fns/locale";
import { format } from "date-fns";

export const toISO = (d) => (d ? format(d, "yyyy-MM-dd") : "");
export const fromISO = (s) => (s ? new Date(s + "T00:00:00") : undefined);

export default function AvailabilityCalendar({ lang, unavailable = [], range, onSelect, numberOfMonths = 1 }) {
  // Une nuit réservée est bloquée, SAUF le 1er jour réservé d'un bloc (le client précédent
  // peut partir ce matin-là) : ce jour reste sélectionnable comme jour de DÉPART (turnover).
  const { disabledDates, checkoutDates } = React.useMemo(() => {
    const booked = new Set(unavailable);
    const minus1 = (s) => { const d = new Date(s + "T00:00:00"); d.setDate(d.getDate() - 1); return format(d, "yyyy-MM-dd"); };
    const checkout = unavailable.filter((s) => !booked.has(minus1(s)));
    const checkoutSet = new Set(checkout);
    const disabled = unavailable.filter((s) => !checkoutSet.has(s)).map(fromISO);
    return { disabledDates: disabled, checkoutDates: checkout.map(fromISO) };
  }, [unavailable]);
  const today = React.useMemo(() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; }, []);

  return (
    <Calendar
      mode="range"
      numberOfMonths={numberOfMonths}
      selected={range}
      onSelect={onSelect}
      fromDate={today}
      locale={lang === "en" ? enUS : frLocale}
      weekStartsOn={1}
      disabled={[{ before: today }, ...disabledDates]}
      modifiers={{ booked: disabledDates, checkout: checkoutDates }}
      modifiersStyles={{
        booked: { color: "#dc2626", textDecoration: "line-through" },
        checkout: { color: "#b45309" },
      }}
      classNames={{
        day_selected: "bg-brand text-white hover:bg-brand hover:text-white focus:bg-brand",
        day_range_middle: "aria-selected:bg-brand-50 aria-selected:text-brand rounded-none",
        day_range_start: "day-range-start bg-brand text-white hover:bg-brand hover:text-white",
        day_range_end: "day-range-end bg-brand text-white hover:bg-brand hover:text-white",
        day_today: "font-semibold text-brand",
      }}
    />
  );
}
